export class OrgStructureNode {
    id: number;
    legalName: string;
    ngtvid: string;
    statusDescription: string;
    isBusy: boolean;
    parent: number;
    children: OrgStructureNode[];
}